import _ from "@lodash";
import CatchErro from "app/Core/Components/CatchErro/CatchErro";
import LookupApp from "app/Core/Components/Lookup/LookupApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import withReducer from "app/store/withReducer";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/EmpresaPessoaProdutoActions";
import reducer from "./Store/Reducers/EmpresaPessoaProdutoReducer";

class EmpresaPessoaProdutoLookup extends XAPPComponent {

    listFilter = () => {
        const { foreignKey = null } = this.props;
        let { xappRouteParams } = this.props;
        if (_.isUndefined(xappRouteParams) || _.isNull(xappRouteParams)) {
            xappRouteParams = this.props.match.params;
        }

        this.props.list("SELECIONAR", xappRouteParams, foreignKey, "pessoa");
    };

    getOptions = () => {
        const { data = null } = this.props.Produtos;
        let AResponse = [];
        if (!_.isNull(data)) {
            AResponse = _.filter(data, { statusregistro: 1 });
        }
        return AResponse;
    };

    render() {
        const { multiSelect, autoSearch, selectFirstAuto, onChange, label = null, required, selected, className, id, readOnly, campoid = null, camponome = null } = this.props;
        var { xappRouteParams } = this.props;
        if (_.isUndefined(xappRouteParams) || _.isNull(xappRouteParams)) {
            xappRouteParams = this.props.match.params;
        }
        return (
            <React.Fragment>
                <CatchErro
                    url={this.props.match.url}
                >
                    <React.Fragment>
                        <LookupApp
                            className={className}
                            label={label}
                            id={id}
                            multiSelect={multiSelect}
                            onChange={onChange}
                            required={required}
                            options={this.getOptions()}
                            selected={selected}
                            pesquisar={this.listFilter}
                            xappRouteParams={xappRouteParams}
                            campoid={!_.isNull(campoid) ? campoid : "idpessoaformulario"}
                            camponome={!_.isNull(camponome) ? camponome : "nome"}
                            filtrodescricao={"UPPER(pessoaformulario.formulario->>''nome'')"}
                            readOnly={readOnly}
                            autoSearch={autoSearch}
                            selectFirstAuto={selectFirstAuto}
                        />
                    </React.Fragment>
                </CatchErro>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
    }, dispatch);
}

function mapStateToProps({ EmpresaPessoaProduto }) {
    return {
        Produtos: EmpresaPessoaProduto,
    };
}

export default withReducer("EmpresaPessoaProduto", reducer)(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaPessoaProdutoLookup)));
